import { Box, Title, Text, Button, Group, Stack, Paper } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSessionContext } from 'supertokens-auth-react/recipe/session';
import { IconHome, IconLayoutDashboard, IconLogin } from '@tabler/icons-react';
import { pageWrapper } from '@/Styles';
import { clientRoutes } from '@/ApiPaths';
import { useStore } from '@/store/Store';
import { DEFAULT_QR_CODE_COLOR } from '@/theme';
import { PageHeader } from '@/components/PageHeader';

/**
 * 404 Page Not Found – shown when user navigates to a non-existent route.
 * Renders within AppLayout (navbar visible), with clear message and navigation actions.
 * If user is not logged in, second button goes to login instead of dashboard.
 */
export function NotFound() {
  const { t } = useTranslation();
  const session = useSessionContext();
  const corporateColor = useStore((s) => s.userProfile.qrCodeColor) || DEFAULT_QR_CODE_COLOR;
  const isLoggedIn = !session.loading && session.doesSessionExist;

  return (
    <Box
      style={{
        ...pageWrapper,
        backgroundColor: '#e3e3e331',
        justifyContent: 'center',
      }}
    >
      <Paper
        shadow="sm"
        radius="md"
        p="xl"
        maw={480}
        style={{
          background: 'white',
          border: '1px solid #e9ecef',
        }}
      >
        <Stack align="center" gap="md">
          <Text
            size="4rem"
            fw={800}
            lh={1}
            style={{
              letterSpacing: '-0.04em',
              color: 'var(--mantine-color-dimmed)',
            }}
          >
            {t('notFound.code')}
          </Text>
          <PageHeader
            variant="section"
            title={t('notFound.title')}
            subtitle={t('notFound.description')}
            accentColor={corporateColor}
            align="center"
            mb={0}
          />
          <Group justify="center" gap="sm" mt="md">
            <Button
              component={Link}
              to={clientRoutes.home}
              leftSection={<IconHome size={18} />}
              variant="filled"
              color={corporateColor}
            >
              {t('notFound.backHome')}
            </Button>
            <Button
              component={Link}
              to={isLoggedIn ? clientRoutes.dashboard : clientRoutes.login}
              leftSection={
                isLoggedIn ? (
                  <IconLayoutDashboard size={18} />
                ) : (
                  <IconLogin size={18} />
                )
              }
              variant="default"
            >
              {isLoggedIn ? t('notFound.backDashboard') : t('notFound.goToLogin')}
            </Button>
          </Group>
        </Stack>
      </Paper>
    </Box>
  );
}
